import { useCallback, useEffect } from 'react';
import Page from '../../../components/page/Page';
import Header from '../../../components/companies/Header';
import { Avatar, Paper, Typography } from '@mui/material';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { useNavigationCore } from '../../../../core/router/navigation';
import { useMeCore } from '../../../../core/modules/me';
import { useGlobalCore } from '../../../../core/modules/global';
import { UPDATE_COMPANY_DIALOG } from '../../../../core/constants/dialog';
import CreateDialog from '../../../components/companies/CreateDialog';
import UpdateDialog from '../../../components/companies/UpdateDialog';
import { useCompanyCore } from '../../../../core/modules/company';
import { Company } from '../../../../core/interfaces/company.interface';
import LocationCityIcon from '@mui/icons-material/LocationCity';

const Companies = () => {
  const { user } = useMeCore();
  const { openDialog } = useGlobalCore();
  const {
    companies,
    noMore,
    setCompany,
    increasePage,
    getCompanies,
    clearCompany,
  } = useCompanyCore();
  const { goToWelcome } = useNavigationCore();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (
      !user ||
      !user.privileges.superAdmin
    ) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  useEffect(() => {
    clearCompany();
  }, [clearCompany]);

  useEffect(() => {
    getCompanies({});
  }, [getCompanies]);

  const selectCompany = useCallback((company: Company) => {
    setCompany(company);
    openDialog(UPDATE_COMPANY_DIALOG);
  }, [openDialog, setCompany]);

  return (
    <>
      <Page
        header={<Header />}
        content={
          !companies.length ? (
            <div className="flex flex-1 items-center justify-center h-full">
              <Typography color="text.secondary" variant="h5">
                No hay companias creadas
              </Typography>
            </div>
          ) : (
            <div className="w-full my-16 sm:col-span-3 px-24 md:px-32">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-24 w-full min-w-0">
                {companies.map((company : Company) => (
                  <Paper
                    className="flex flex-col flex-auto items-center shadow rounded-2xl overflow-hidden cursor-pointer"
                    key={company.id}
                    onClick={() => selectCompany(company)}
                  >
                    <div className="flex flex-col flex-auto w-full p-32 items-center text-center">
                      <Avatar
                        alt="company photo"
                        className="w-128 h-128"
                      >
                        <LocationCityIcon className="w-96 h-96" />
                      </Avatar>
                      <Typography className="font-medium text-slate-950 mt-8">
                        {company.name}
                      </Typography>
                    </div>
                  </Paper>
                ))}
              </div>
              {!noMore ? (
                <div className="text-center underline cursor-pointer my-24" onClick={increasePage}>
                  Mostras más
                </div>
              ) : null}
            </div>
          )
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CreateDialog />
      <UpdateDialog />
    </>
  );
};

export default Companies;
